import React from "react";
import { IApplication } from "../../types";

interface ApplicationDetailsModalProps {
  application: IApplication;
  onClose: () => void;
}

const ApplicationDetailsModal = ({
  application,
  onClose,
}: ApplicationDetailsModalProps) => {
  const user = application.userId;

  return (
    <div className="fixed inset-0 p-2 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Application Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>

        <div className="space-y-4">
          {/* User Information */}
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Applicant</h3>
              <p>
                {user?.firstName} {user?.lastName}
              </p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Email</h3>
              <p>{user?.email}</p>
            </div>
          </div>

          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Phone</h3>
              <p>{user?.phone}</p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Profession</h3>
              <p>{user?.profession}</p>
            </div>
          </div>

          {/* Application Information */}
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Post ID</h3>
              <p>{application.postId}</p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Status</h3>
              <p
                className={`capitalize ${
                  application.status === "accepted"
                    ? "text-emerald-500"
                    : application.status === "pending"
                    ? "text-amber-500"
                    : "text-rose-500"
                }`}
              >
                {application.status}
              </p>
            </div>
          </div>

          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">
                Expected Salary
              </h3>
              <p>₦{application.expectedSalary}</p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Applied On</h3>
              <p>{new Date(application.createdAt).toLocaleDateString()}</p>
            </div>
          </div>

          <div>
            <h3 className="font-medium text-gray-500 text-sm">Cover Letter</h3>
            <p className="whitespace-pre-line text-sm text-gray-700">
              {application.coverLetter}
            </p>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-rose-500 text-rose-500 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationDetailsModal;
